import {
  buildDurationTypeLabels,
  buildInsightTypeLabels,
  DURATION_TYPE_VALUES,
  INSIGHT_TYPE_CONFIG,
} from '@/entities/opportunity';
import type { DurationTypeValue, InsightType } from '@/entities/opportunity';

// Built per call, not once at module scope: the labels come from i18n, so a module-level
// array would capture whatever language was active when this file was first evaluated.
export function buildInsightTypeOptions(): { value: InsightType; label: string }[] {
  const labels = buildInsightTypeLabels();

  return (Object.keys(INSIGHT_TYPE_CONFIG) as InsightType[]).map((value) => ({
    value,
    label: labels[value],
  }));
}

export function buildOpportunityTypeOptions(): { value: DurationTypeValue; label: string }[] {
  const labels = buildDurationTypeLabels();

  return DURATION_TYPE_VALUES.map((value) => ({ value, label: labels[value] }));
}

export function chipClass(active: boolean, isAllOption = false) {
  return [
    'px-3 py-1.5 rounded-full border text-sm transition-colors cursor-pointer select-none',
    active
      ? isAllOption
        ? 'bg-background text-foreground border-border'
        : 'bg-accent text-accent-foreground border-accent'
      : 'bg-background text-foreground border-border hover:bg-accent',
  ].join(' ');
}
